import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';

/**
 * Generated class for the RfqPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-rfq',
  templateUrl: 'rfq.html',
})
export class RfqPage {
  measurement: any[] = [{ id: '1', name: 'CRT' }, { id: '2', name: 'CUM' }, { id: '3', name: 'KGS' }, { id: '4', name: 'LTR' }, { id: '5', name: 'MTR' }, { id: '6', name: 'NOS' }, { id: '7', name: 'PRS' }, { id: '8', name: 'SQM' }, { id: '9', name: 'THN' }, { id: '10', name: 'TON' }];

  Currency: any = [];
  allCountrys: any = [];
  lead_data: any; unit_of_measurement: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private apiProvider: ApiProvider, private alertCtrl: AlertController,) {
    this.lead_data = navParams.get('data');
    console.log(this.lead_data.lead_unit_of_measurement);
    this.unit_of_measurement = this.lead_data.lead_unit_of_measurement;
    this.getcurrencydata();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RfqPage');
  }


  getcurrencydata() {
    this.apiProvider.getCurrency().subscribe((res: any) => {
      console.log(res.data)
      this.Currency = res.data;
      console.log(this.Currency)
    }, er => {
      console.log(er);
    })

    this.apiProvider.getallCountrys().subscribe((res: any) => {
      this.allCountrys = res.data;
      console.log(this.allCountrys);
    }, er => {
      console.log(er);
    })
  }
  submitrequest(quantity, unit_of_measurement, unit_price, currency, country) {
    console.log(unit_of_measurement);

    const usrid = JSON.parse(localStorage.getItem('user_data'))
    console.log(usrid);

    var data = {
      'quantity': quantity,
      'unit_of_measurement': unit_of_measurement,
      'unit_price': unit_price,
      'currency': currency.currency_id,
      'country': country.continent_id,
      'lead_id': this.lead_data.lead_id,
      'usr_id': usrid[0].usr_id,
      'reqst_sender_id': this.lead_data.created_by,
      'request_email': usrid[0].usr_email,
      'request_usr': usrid[0].usr_nm,
      'lead_display_id': this.lead_data.lead_display_id,
      'sender_email': this.lead_data.usr_email,
      'sender_name': this.lead_data.salutation + " " + this.lead_data.usr_nm + " " + this.lead_data.middle_nm + " " + this.lead_data.last_nm
    }
    console.log(data);
    this.apiProvider.submitrequestdata(data).subscribe((res: any) => {
      console.log(res);
      if (res.status == 200) {
        const alert = this.alertCtrl.create({
          // cssClass: 'my-custom-class',
          cssClass: 'successcolorclass',
          // title: res.referral,
          // subTitle: 'Congratulations!, Your Request has received and our team will get back to you in next 72 Hrs',
          // title: res.referral,
          subTitle: 'Congratulations!, Your Request has been sent successfully',
          mode: 'ios',
          buttons: [{
            text: 'Ok',
            handler: () => {
              this.navCtrl.setRoot('HomePage');

            }
          },
          ]
        });
        alert.present();

      }

    })
    console.log("hitted");

  }
  goBack() {
    this.navCtrl.pop();
  }
  gotopage(id) {
    if (id == 0) {
      this.navCtrl.setRoot('HomePage');
    } else if (id == 1) {
      this.navCtrl.push('StartLeadsPage');
    } else if (id == 2) {
      this.navCtrl.push('ToolkitPage');
    } else if (id == 3) {
      this.navCtrl.push('ChatChaptersPage');
    } else if (id == 4) {
      this.navCtrl.push('LeadsTabsPage');
    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/rfq/rfq.ts